export default {
  KYC_3_HEADER: "What best describes your employment status?",
  KYC_3_SUBHEADING:
    "This is information we are required to collect to verify our customer information.",
  RADIO_ITEMS: [
    {
      label: "Employed",
      value: "Employed",
    },
    {
      label: "Self-employed",
      value: "Self-employed",
    },
    {
      label: "Student",
      value: "Student",
    },
    {
      label: "Unemployed",
      value: "Unemployed",
    },
  ],
  FORM_ITEMS: [
    {
      label: "Name of Employer",
      errorMessage: "Please enter valid name of the employer",
      value: "nameOfEmployer",
      errorValue: "nameOfEmployerError",
    },
    {
      label: "Employer Address",
      errorMessage: "Please enter valid employer address",
      value: "employerAddress",
      errorValue: "employerAddressError",
    },
    {
      label: "Occupation / Job Title",
      errorMessage: "Please enter valid occupation / job title",
      value: "occupation",
      errorValue: "occupationError",
    },
  ],
  KYC_3_BUTTON_HEADING: "Next",
};
